var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8723 21.4901V12.7161C32.8723 9.03471 29.9008 6.0896 26.2483 6.0896H24.7006V10.0164C24.7006 15.4771 20.2433 19.8948 14.7335 19.8948H10.7715V21.4901C10.7715 25.1101 13.743 28.0552 17.3955 28.0552H26.2483C29.9008 28.0552 32.8723 25.1101 32.8723 21.4901Z",
    fill: "#A7CD45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2951 10.0164V6.0896H17.333C13.6805 6.0896 10.709 9.03471 10.709 12.7161V16.6429H14.671C18.3236 16.6429 21.2951 13.6364 21.2951 10.0164Z",
    fill: "#106C3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84773 9.15735H0V11.9797C0 14.5567 2.10484 16.6428 4.70494 16.6428H7.55267V13.8204C7.55267 11.2435 5.44782 9.15735 2.84773 9.15735Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo-square.a405676d12db9e57c46f1d755d5a9978.svg";
export { ForwardRef as ReactComponent };